import { PAGE_TYPE_INDUSTRY, PAGE_TYPE_TAG } from '../constants';
import { convertTagPageId } from '../convertTagPageId';

const clearFalselyValues = (data) =>
    Object.keys(data).reduce((params, propName) => {
        const value = data[propName];
        if (!value) {
            return params;
        }
        return {
            ...params,
            [propName]: value,
        };
    }, {});

/**
 * @typedef Input
 * @property {String | undefined} tagType
 * @property {String | undefined} tagId
 * @property {String | undefined} brandName
 * @property {String | undefined} slogan
 * @param {Input}
 */
export const getBriefParams = ({ brandName, slogan, tagId, tagType }) => {
    let params = {
        get_started_brand_name: brandName,
        get_started_slogan: slogan,
    };

    const adaptedId = tagId && convertTagPageId(tagId);
    if (tagType === PAGE_TYPE_INDUSTRY) {
        params = { ...params, get_started_industry: adaptedId };
    }

    if (tagType === PAGE_TYPE_TAG) {
        params = { ...params, get_started_business: adaptedId };
    }

    return clearFalselyValues(params);
};
